import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServicesOverview = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      title: "Position Print Fabric Manufacturing",
      description: "Expert manufacturing of position print fabrics with precision printing technology. High-quality Polyester, Natural Crepe, Velvet Embroidery, Chinon, and Shimmer with superior finish.",
      icon: "Factory",
      image: "https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=400&h=300&fit=crop",
      features: ["Position Print Expertise", "Premium Quality", "Various Materials", "Bulk Production"],
      color: "textile"
    },
    {
      id: 2,
      title: "Wholesale Supply",
      description: "Competitive wholesale pricing for position print fabrics and other premium materials. Flexible MOQs and reliable supply chain for fabric dealers and retailers.",
      icon: "Package",
      image: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?w=400&h=300&fit=crop",
      features: ["Competitive Pricing", "Bulk Discounts", "Regular Supply", "Quality Assured"],
      color: "secondary"
    },
    {
      id: 3,
      title: "Custom Position Print Orders",
      description: "Customized position print fabric solutions with specific patterns, colors, and finishes tailored to your unique design requirements and specifications.",
      icon: "Palette",
      image: "https://images.pixabay.com/photo/2017/08/07/14/02/people-2604149_1280.jpg?w=400&h=300&fit=crop",
      features: ["Custom Prints", "Pattern Options", "Special Finishes", "Flexible Orders"],
      color: "primary"
    },
    {
      id: 4,
      title: "Fabric Consultation",
      description: "Expert guidance on position print fabrics, quality standards, and material selection for your garment or textile projects. Professional fabric consultation services.",
      icon: "Users",
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop",
      features: ["Expert Advice", "Material Selection", "Quality Check", "Sample Available"],
      color: "golden"
    }
  ];

  const handleLearnMore = () => {
    navigate('/about');
  };

  const handleGetQuote = () => {
    navigate('/contact');
  };

  return (
    <section className="py-8 sm:py-12 lg:py-16 xl:py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-poppins font-bold text-primary mb-2 sm:mb-3 lg:mb-4">
            Our Premium Services
          </h2>
          <p className="text-sm sm:text-base lg:text-lg xl:text-xl text-text-secondary max-w-3xl mx-auto px-4">
            Comprehensive fabric manufacturing and wholesale solutions that combine traditional craftsmanship with quality standards to deliver exceptional fabrics for every need.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6 mb-8 sm:mb-12 lg:mb-16">
          {services?.map((service) => (
            <div
              key={service?.id}
              className="card-elevated group hover:shadow-heritage transition-all duration-300 animate-fade-in"
            >
              {/* Service Image */}
              <div className="relative overflow-hidden rounded-t-lg h-40 sm:h-48 lg:h-52">
                <Image
                  src={service?.image}
                  alt={service?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className={`absolute top-3 sm:top-4 left-3 sm:left-4 w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 bg-${service?.color} rounded-full flex items-center justify-center`}>
                  <Icon name={service?.icon} size={20} color="white" className="sm:w-6 sm:h-6" />
                </div>
              </div>

              {/* Service Content */}
              <div className="p-4 sm:p-5 lg:p-6">
                <h3 className="text-base sm:text-lg lg:text-xl font-poppins font-semibold text-primary mb-2 sm:mb-3 leading-tight">
                  {service?.title}
                </h3>
                <p className="text-xs sm:text-sm lg:text-base text-text-secondary mb-3 sm:mb-4 leading-relaxed">
                  {service?.description}
                </p>

                {/* Features */}
                <div className="space-y-1.5 sm:space-y-2 mb-4 sm:mb-5 lg:mb-6">
                  {service?.features?.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <Icon name="Check" size={14} className="text-success flex-shrink-0 sm:w-4 sm:h-4" />
                      <span className="text-xs sm:text-sm text-text-secondary">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  className="group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300 text-xs sm:text-sm font-semibold"
                  onClick={handleLearnMore}
                  iconName="ArrowRight"
                  iconPosition="right"
                  iconSize={14}
                >
                  Learn More
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;